import styled from "styled-components";
import { shade700 } from "../../../styles/tokens";

// TEXT

// STYLES
export const Container = styled.div<{ $backgroundColor?: string }>`
  width: 100%;
  padding: 0.625rem 0;
  display: flex;
  justify-content: center;
  cursor: grab;
  background-color: ${({ $backgroundColor }) =>
    $backgroundColor || "transparent"};

  &:active {
    cursor: grabbing;
  }
`;
export const HandleBar = styled.div`
  width: 3rem;
  height: 0.25rem;
  border-radius: 0.625rem;
  background-color: ${shade700};
`;

// DATA

// TYPES
export type Props = {
  backgroundColor?: string;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
